module.exports = __webpack_public_path__ + "media/react/assets/FeedbackSettingsIcon-bd238436568615871520835ea6f95179.svg";